/* template */
<template><div :class="({'es-card':true, margin:margin})"><template v-if="(!hideTitle)"><mpx-view @tap="onSideClick" class="es-card__title"><slot name="title"><div class="es-card__title-text">{{title}}</div></slot><div class="es-card__title-side"><slot name="titleSide"><div :style="[({color: sideColor || '#666666'})] | transRpxStyle" class="es-card__title-side-text">{{sideTitle}}</div><es-icon name="angle-right" :size="(!sideTitle ? 20 : 16)" :color="(sideColor || '#666666')" v-if="(sideIcon)"/></slot></div></mpx-view><div class="es-card__divider" v-if="(!hideDivider)"></div></template><div><slot/></div></div></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"mc3d6ce32"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc3d6ce32"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexc3d6ce32%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexc3d6ce32%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc3d6ce32"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexc3d6ce32/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
